import React, { useContext, useEffect } from "react";
import BuildingPresentation from "./BuildingPresentation";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { API_URL_BUILDING_SLUG_NEW } from "../../config/config";
import { LanguageContext } from "../../containers/languageprovider";
import { isoLanguageMap } from "../languages";

const SlugBuildingPresentation = () => {
  const { slug, lang } = useParams();

  const { userLanguage, userLanguageChange } = useContext(LanguageContext);

  useEffect(() => {
    if (lang) userLanguageChange(lang);
  }, [lang]);

  useEffect(()=>{

  },[userLanguage])

  const setMetaTags = (building) => {
    if (building.info) {
      const url = window.location.href;
      const originUrl = new URL(url).origin;

      console.log("url : ", url);
      console.log("url origin : ", new URL(url).origin);
      const canonicalUrl = building.info.getCanonicalUrl(userLanguage);
      const alternateUrls = building.info.getAlternateUrls();
      console.log("canonicalLink : ", canonicalUrl);
      console.log("alternateUrls : ", alternateUrls);
      const head = document.head;
      //Set html lang attribute with the site language
      const html = document.documentElement;
      html.lang = isoLanguageMap[userLanguage];
      // Set canonical link
      const canonicalLink = document.querySelector('link[rel="canonical"]');
      if (canonicalLink) {
        canonicalLink.href = originUrl + canonicalUrl;
      } else {
        const canonicalLink = document.createElement("link");
        canonicalLink.rel = "canonical";
        canonicalLink.href = originUrl + canonicalUrl;
        head.appendChild(canonicalLink);
      }

      //Set alternateUrls
      // Map through the object entries
      Object.entries(alternateUrls).forEach(([lang, link]) => {
        // Set the language and URL variables based on the key-value pairs
        console.log("lang  : ", lang);
        console.log("link  : ", link);
        const alternateLink = document.createElement("link");
        alternateLink.rel = "alternate";
        alternateLink.href = originUrl + link;
        alternateLink.hreflang = lang;
        head.appendChild(alternateLink);
      });

      // Cleanup function to remove alternate links when component is unmounted
      return () => {
        Object.keys(alternateUrls).forEach((lang) => {
          const alternateLink = document.querySelector(
            `link[hreflang="${lang}"]`
          );
          if (alternateLink) {
            document.head.removeChild(alternateLink);
          }
        });
      };
    }
  };

  return (
    <BuildingPresentation
      API={API_URL_BUILDING_SLUG_NEW}
      apiParameter={slug}
      setMetaTags={setMetaTags}
      isToken={false}
      // isoLanguageMap={isoLanguageMap}
    />
  );
};

export default SlugBuildingPresentation;
